// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mb-1";
export var spinner = "_mb-0";